import React from "react";

import { Link } from "react-router-dom";

import "../../styles/pages/SidebarLink.css";

const SidebarLink = ({ LINK, active, handleActiveLink }) => {
  return (
    <Link
      to={LINK.to}
      className="sidebarlink"
      onClick={() => handleActiveLink(LINK.active)}
    >
      {active === LINK.active ? LINK.Active : LINK.Inactive}
    </Link>
  );
};

export default SidebarLink;
